import { RouterProvider } from '@rocketlane/rocket-router';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { InitWorkerApi } from 'initWorker';
import './index.css';
import './tailwind.css';
import 'react-cmdk/dist/cmdk.css';
import { router } from 'routes/app-routes';
import { initDatadog, initDatadogRum } from 'vendor/datadog-rum';

initDatadog();
initDatadogRum();

// disable MSW in development and when cypress is running
if (process.env.NODE_ENV === 'development' && !window.Cypress) {
  import('./mocks/browser').then(({ worker }) => {
    worker.start({ onUnhandledRequest: 'bypass' });
  });
}

if (window.location.hostname === 'localhost') {
  InitWorkerApi.setData();
}

const container = document.getElementById('root') as HTMLElement;

export const root = createRoot(container);

root.render(
  // Disabling strict mode now. Because its breaking Antd components like Popover, Tooltip etc
  // context: https://github.com/ant-design/ant-design/issues/26136, https://github.com/ant-design/ant-design/issues/34876
  // <StrictMode>
  <Suspense fallback={null} name="RootSuspense">
    <RouterProvider router={router} />
  </Suspense>,
  // </StrictMode>
);
